/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ACHAccountHolderTypeEnum {
    PERSONAL = 'Personal',
    BUSINESS = 'Business',
}